import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export enum PageLayout {
  Authorized = 'authorized', // Key for authorized layout
  UnAuthorized = 'unauthorized', // Key for unauthorized layout
  Error = 'error', // Key for error layout
}

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  constructor() {}

  private layoutSubject = new BehaviorSubject<PageLayout>(
    PageLayout.UnAuthorized
  );
  private organizationIdSubject = new BehaviorSubject<
    string | number | undefined
  >(undefined);
  private organizationNameSubject = new BehaviorSubject<
    string | number | undefined
  >(undefined);
  // Fires when an FCM push is received while the tab is in the foreground.
  // Firebase's onMessage() (authorized-layout.component.ts) never triggers a
  // native browser notification and has no other side effect, so components
  // that show unread counters (side-menu, dashboard) subscribe here to know
  // a new message/ticket just arrived instead of going stale until the next
  // navigation/reload. A plain Subject (not BehaviorSubject) is enough: late
  // subscribers don't need to replay a push that already happened.
  private newNotificationSubject = new Subject<void>();

  public layout$ = this.layoutSubject;
  public organizationId$ = this.organizationIdSubject;
  public organizationName$ = this.organizationNameSubject;
  public newNotification$ = this.newNotificationSubject.asObservable();

  setLayout(value: PageLayout) {
    console.log('Setting layout to:', value);
    if (value === PageLayout.UnAuthorized || value === PageLayout.Error) {
      this.organizationIdSubject.next(undefined);
    }
    this.layoutSubject.next(value);
  }

  setOrganizationId(value: string | number | undefined) {
    console.log('Setting organization ID to:', value);
    this.organizationIdSubject.next(value);
  }

  setOrganizationName(value: string | undefined) {
    this.organizationNameSubject.next(value);
  }

  notifyNewNotification(): void {
    this.newNotificationSubject.next();
  }
}
